import { FilerTypeEnum } from "src/app/app.model";
import { filerTypeGuard } from "./filer-guard-factory";

export const OnlyCommitteeGuard = filerTypeGuard(FilerTypeEnum.Campaign);